import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Field, Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import FormikInput from '../../../../../../CommonComponents/FormikInput';
import FormikSelect from '../../../../../../CommonComponents/FormikSelect';
import Spinner from '../../../../../../CommonComponents/Spinner';
import { PrimaryButton, SecondaryButton } from '../../../../../../CommonComponents/Button';
import { addDriverLicense } from '../../../../../ExperianActions';
import { Footer, Label, LabelText } from '../../../../../components/EnrollForm/EnrollFormStyles';
import { Title } from '../../../ReportStyles';
import { STATES } from '../../../../../components/EnrollForm/EnrollFormConstants';
import ExperianContext from '../../../../../ExperianContext';

const DriverLicenseForm = ({ onCancel, onRequestClose }) => {
  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={{
        driverLicenseNumber: '',
        driverLicenseState: '',
      }}
      onSubmit={async (values, actions) => {
        try {
          await dispatch(addDriverLicense(clientId, subscriberId, values));
          onRequestClose();
          onCancel();
        } catch {
          // Keep the modal open to display the error
        } finally {
          actions.setSubmitting(false);
        }
      }}
      render={({ isSubmitting }) => (
        <Form>
          {isSubmitting && <Spinner />}
          <Title>Monitor Driver&apos;s License</Title>
          <Label>
            <LabelText>State</LabelText>
            <Field
              type="text"
              name="driverLicenseState"
              component={FormikSelect}
              options={STATES}
              size="small"
            />
          </Label>
          <Label>
            <LabelText>Driver&apos;s License</LabelText>
            <Field type="text" name="driverLicenseNumber" component={FormikInput} size="small" />
          </Label>
          <Footer>
            <SecondaryButton onClick={onCancel}>Cancel</SecondaryButton>
            <PrimaryButton type="submit" disabled={isSubmitting}>
              Submit
            </PrimaryButton>
          </Footer>
        </Form>
      )}
    />
  );
};

DriverLicenseForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default DriverLicenseForm;
